import { IChallenge } from "./IChallenge";

export class EmptyChallenge implements IChallenge {
  Guid: string = "";
  Title: string = "";
  Subtitle: string = "";
  Tags: string[] = [];
  Region: string = "WORLDWIDE";
  ImageSrc: string = "";
  CallToActions: import("./ICallToAction").ICallToAction[] = [];
  BeenFeatured: boolean = false;
  StartCount: number = 0;
  ShareCount: number = 0;
  UpVotes: number = 0;
  DownVotes: number = 0;
  CreatedAt: string = "";
  Theme: string = "";
}

export const EmptyChallengeList: IChallenge[] = [
  new EmptyChallenge(),
  new EmptyChallenge(),
  new EmptyChallenge(),
  new EmptyChallenge(),
  new EmptyChallenge(),
  new EmptyChallenge(),
];
